module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_7016.5c5fb9cf.png";